<template>
  <v-app>
    <v-dialog v-model="dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{ progressMessage }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <div class="bg-color" color="#F2F2F2"></div> -->
    <!-- <img class="bg-image" src="../../assets/Background Pattern.png" /> -->
    <img class="bg-image" src="../../assets/women-working.png" />
    <div class="bg-color"></div>
    <!-- <img class="bg-image2" src="../../assets/Background/Rectangle 1.png" /> -->
    <img class="bg-image3" src="../../assets/Background/Rectangle 3.png" />
    <img class="bg-image4" src="../../assets/Background/Rectangle 2 .png" />
    <v-row justify="center" align="center" v-show="showLogin">
      <v-container fluid class="fill-height login-wrapper" justify="center" align="center">
        <v-row justify="center">
          <v-col cols="12" class="d-flex flex-column align-center justify-center">
            <div class="logo-container-top text-center mb-8">
              <img src="../../assets/IntelligentHealthOS.png" class="top-logo-img" alt="Intelligent Health OS Logo" />
            </div>
            <v-card class="card-login" outlined height="100%" 
                style="border-radius: 26px;
                width: 450px;
                position: relative;
                margin-top: 0px;
                background-color: rgba(255, 555, 255, 0.8);
                ">
              <div class="text-center">
                <img src="@/assets/final-Logo.png" style="
            width: 30%; 
            margin-top: 40px;
            background-color: transparent;
            " alt="Logo" />
              </div>

              <!-- <v-divider></v-divider> -->

              <v-card-text style="padding-bottom: 40px;">
                <v-container fluid class="card-yugioh">
                  <v-form v-model="valid" @submit.prevent="login">
                    <v-row>
                      <v-col cols="12">
                        <div class="mb-2">
                          <span>Username</span>
                        </div>
                        <div class="custom-input">
                          <v-text-field name="username" placeholder="Username" v-model="username" id="username" prepend-inner-icon="mdi-account"
                            :rules="[() => username.length > 0 || 'Please enter username']" required outlined
                            density="compact"></v-text-field>
                        </div>

                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="mb-2 mt-4">
                          <span>Password</span>
                        </div>
                        <div class="custom-input mb-7">
                            <v-text-field
                              density="compact"
                              outlined
                              name="password"
                              v-model="password"
                              placeholder="Password"
                              prepend-inner-icon="mdi-lock"
                              id="password"
                              :append-icon="e3 ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="e3 ? 'password' : 'text'"
                              @click:append="e3 = !e3"
                              :rules="[() => password.length > 0 || 'Please enter password']"
                              :error="!!backendPasswordError"
                              :error-messages="backendPasswordError" 
                              required
                            ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-btn block color="primary" type="submit" height="70px" class="login-btn login-gradient-btn">
                          {{$t('login.login')}}
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-form>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-footer color="#003057" height="43px" padless dark>
      <v-row justify="center" no-gutters>
        <span class="justify-center text-xs-center">
          <small class="footer-text">copyright 2025 Innotech Laboratory Service Co., Ltd.
          </small>
        </span>
      </v-row>
    </v-footer>
  </v-app>
</template>

<style lang="css" scoped>
  body, .v-application--wrap {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden; 
    display: flex;
    flex-direction: column;
    background: transparent; /* background images handle it */
  }

  /* Main Wrapper for Login */
  .login-wrapper {
    z-index: 1; /* ensure it's above background */
    padding: 20px;
  }
  .logo-container-top {
    width: 100%;
    max-width: 600px; /* cite: prevent it from being too wide */
    position: relative;
    /*cite: transform: translate(-50%, -50%); - removed this relative positioning logic */
  }

  .top-logo-img {
    width: 100%;
    height: auto;
    object-fit: contain; /* cite: preserve aspect ratio, no stretch */
    display: block;
    margin: 0 auto;
    /*cite: position: absolute; - removed position absolute */
  }
.custom-input {
  background: white;
  height: 54px;
  border-radius: 8px; 
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); /* เงา */
}

.forgot-password {
  color: #000000;
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
}

.login-btn {
  border-radius: 10px;
  font-size: 18px !important;
  text-transform: none; /* ปิดการแปลงตัวอักษร */
  padding: 20px 0;
}
.login-gradient-btn {
  background: linear-gradient(90deg, #003c9b 0%, #0070f8 100%);
  color: white !important;
  border-radius: 12px;
  font-size: 20px;
  font-weight: 600;
  transition: 0.3s;
}

.login-gradient-btn:hover {
  opacity: 0.9;
}

.login-gradient-btn:active {
  transform: scale(0.98);
}
.register-text {
  color: #555;
  font-size: 14px;
  margin: 0;
}
  .conrainer-text {
    position: relative;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }
  .conrainer-text p{
    font-size: 26px;  
  }
  .conrainer-text h1{
    font-size: 30px;  
  }
  .bg-image{
    position: absolute;
    /* bottom:-1; */
    overflow: hidden;
    z-index: 0;
    width: 100%;
    height: 100%;
  }
  /* สี */
  .bg-image2{
    position: absolute;
    top: 48.9%;
    left: 1.5%;
    height: 48.9%;
    width: 96%;
  }



  .bg-image3{
    position: absolute;
    overflow: hidden;
    justify-content: center;
    align-items: center;
    left: 22%;
    height: 30%;
    width: 58.5%;
    top: 56.2%;
  }


  .bg-image4 {
    position: absolute;
    overflow: hidden;
    height: 50.5%;
    bottom: 0;
    width: 100%;
  }
  .bg-color{
    position: absolute;
    overflow: hidden; 
    background-color: #6fc3ffb2;
    z-index:0;
    width: 100%;
    height: 100%;
  }
  .footer-text{
    position: relative;
    align-items: center;
    justify-content: center;
    bottom:10px;
  }
  .custom-label .v-label {
  font-size: 20px; /* ปรับขนาดของฟอนต์ใน Label */
  }
  .custom-label .v-input__control {
    font-size: 18px; /* ปรับขนาดของฟอนต์ในฟิลด์ */
  }
  
  /* ขนาดหน้าจอที่กว้างมาก (เช่น Desktop ใหญ่) */
  @media screen and (min-width: 1200px) {
    
    .conrainer-text {
    position: relative;
    top: 7%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    
  }
  .card-login{
    margin-bottom: -1px;
  }
  .top-logo-img { max-width: 500px; }
  .card-yugioh{
    height: 70%;
  }
  
    .conrainer-text p{
    font-size: 18px;  
  }
  .conrainer-text h1{
    font-size: 22px;
  }
  }

  /* ขนาดหน้าจอ Desktop */
  @media screen and (min-width: 992px) and (max-width: 1199px) {
    
    .conrainer-text {
    position: relative;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    margin-bottom: 1px;
  }
 .card-login .text-center img{
    margin-bottom: -1px;
  }
  .top-logo-img { max-width: 400px; }
 
    .conrainer-text p{
    font-size: 16px;  
    }
    .conrainer-text h1{
      font-size: 22px;  
    }
  }

  /* ขนาดหน้าจอ Tablet */
  @media screen and (min-width: 768px) and (max-width: 991px) {
    
    .conrainer-text {
    position: relative;
    top: 7%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    margin-bottom:-7px;
  }
  .custom-input {
  height: 54px;
  border-radius: 8px; 
  margin-bottom: 10px;
  margin-top: -1px;
}

    .conrainer-text p{
      font-size: 16px;  
    }
    .conrainer-text h1{
        font-size: 20px;  
    }
  }

  /* ขนาดหน้าจอ Smartphone แนวนอน */
  @media screen and (min-width: 576px) and (max-width: 767px) {
    body {
      background-color: lightgoldenrodyellow;
    }
    .conrainer-text {
    position: relative;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    margin-bottom: 1px;
  }
 
    .conrainer-text p{
    font-size: 16px;  
    }
    .conrainer-text h1{

      font-size: 20px;  
    }
  }

  /* ขนาดหน้าจอ Smartphone แนวตั้ง */
  @media screen and (max-width: 575px) {
    
    .conrainer-text {
    position: relative;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    margin-bottom: 1px;
  }
    .conrainer-text p{
    font-size: 16px;  
    }
    .conrainer-text h1{
      font-size: 20px;  
    }
  }
</style>

<script>
  import {AUTH_REQUEST} from 'actions/auth'
  import { mapGetters } from 'vuex'
  import languagePicker from '../navigation/languagePicker.vue'
  import SqreenFooter from '@/components/footer/index.vue'
  export default {
    name: 'login',
    components: {
      languagePicker,
      SqreenFooter,
    },
    data () {
      return {
        showPass: false,
        username: '',
        password: '',
        e3: true,
        first: '',
        valid: '',
        backendPasswordError: '',
        line_user_id: '',
        stringFormat: require('string-format'),
        sexCode: '',
        menu2: false,
        date: null,
        dateFormatted: null,
        userNameForm: '',
        anonymousName: '',
        firstName: '',
        lastName: '',
        mobileNo: '',
        eMail: '',
        anonymousFlag: false,
        agreeConditionFlag: false,
        firstNameShow: true,
        lastNameShow: true,
        anonymousNameShow: false,
        questionnaire1: '',
        questionnaire2: '',
        questionnaire3: '',
        questionnaire4: '',
        questionnaire5: '',
        questionnaire6: '',
        questionnaire7: '',
        yes: 'ใช่',
        no: 'ไม่ใช่',
        agreeConditionDisable: true,
        /* reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/, */
        reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
        dialogProgress: false,
        progressMessage: '',
        dialogForgotPassword: false,
        usernameForgot: '',
        showUsernameForgot: true,
        showUsernameForgotCard: false,
        dataUser: {},
        btnSaveFlag: false,
        fixed: '',
        breadcrumbsRegister: [
          {
            text: this.$t('login.login'),
            disabled: false,
            href: 'login',
          },
          {
            text: this.$t('login.register'),
            disabled: true,
          },
        ],
        breadcrumbsCondition: [
          {
            text: this.$t('login.register'),
            disabled: true,
          },
          {
            text: this.$t('login.condition'),
            disabled: false,
          },
        ],
        breadcrumbsquestionnaire: [
          {
            text: this.$t('login.register'),
            disabled: true,
          },
          {
            text: this.$t('login.questionnaire'),
            disabled: false,
          },
        ],
        showLogin: true,
        showFistPage: false,
      }
    },
    methods: {
      login: function () {
        const { username, password } = this
        this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
          // this.$socket.emit('userConnect', {
          //   userID: localStorage.getItem('username')
          // })
          this.$router.push('/').catch(() => {})
        }).catch((error) => {
          // this.$swal({type: 'error', title: typeof (error.message) !== 'undefined' ? error.message : error})
          /* this.$swal({type: 'error', title: error.message}) */
          this.backendPasswordError = error.message
          /* console.log(error.response, 'error.response')
          console.log(error, 'error')
          if (response.data.reasonCode === 501) {
            this.backendPasswordError = 'Invalid password'
          } else {
            this.backendPasswordError = response.data.reasonText
          } */
        })
      },
      init () {
        console.log('event init')
        this.$nextTick(this.$refs.refUserName.focus)
        /* this.$refs.refUserName.focus() */
      },
      forgotPassword () {
        console.log(this.usernameForgot, 'Forgot')
        var messageCustom = ''
        if (!this.usernameForgot) {
          messageCustom = messageCustom + this.$t('login.messageUserName') + '<br />'
        }
        if (messageCustom) {
          this.$swal({type: 'error', html: messageCustom})
          return false
        }
        this.retrieveUserInfo()
      },
      openDialogForgotPassword () {
        this.dialogForgotPassword = true
        this.showUsernameForgot = true
        this.usernameForgot = ''
        this.$nextTick(this.$refs.usernameForgot.focus)
        this.showUsernameForgotCard = false
      },
      closeDialogForgotPassword () {
        this.dialogForgotPassword = false
        this.showUsernameForgot = true
        this.usernameForgot = ''
        this.showUsernameForgotCard = false
      },
      sendMail () {
        var base64ParmUser = btoa(this.usernameForgot)
        console.log(base64ParmUser, 'base64ParmUser')
        this.axios.post(process.env.VUE_APP_API + '/user/sendMailForgotPassword', {
          user_id: this.usernameForgot,
          email: this.dataUser.email,
          patientName: this.dataUser.patientname,
          base64Parm: base64ParmUser,
          lang: this.$i18n.locale,
        })
          .then(response => {
            if (response.data.isSuccess) {
              console.log(response.data.data, 'response.data.data')
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
    },
  }
</script>
<style scoped>
.v-dialog {
  overflow: unset !important; /* Remove overflow auto */
}
</style>